import { getSubStepValues } from '#models/general/steps';
import AdelphiFieldsRow from '#components/business/AdelphiFieldsRow';
import Input from '#components/general/Input';

import styles from './styles.module.scss';
import { SPIRIT_REDUCTION_CALCULATIONS_FIELDS, SPIRIT_REDUCTIONS_SUBSTEPS_IDS } from './constants';

export const getCalculationsFields = ({ values, errors }) => {
  const getCalculationsValues = getSubStepValues(SPIRIT_REDUCTIONS_SUBSTEPS_IDS.CALCULATIONS, values, errors);
  return [
    {
      key: 'firstRow',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.mainInfoTableColumns,
      fields: [
        {
          ...getCalculationsValues(SPIRIT_REDUCTION_CALCULATIONS_FIELDS.BULK_X_TCF),
          Component: Input,
          noMargin: true
        },
        {
          ...getCalculationsValues(SPIRIT_REDUCTION_CALCULATIONS_FIELDS.PLUS_9),
          Component: Input,
          noMargin: true
        }
      ]
    },
    {
      key: 'secondRow',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.mainInfoTableColumns,
      fields: [
        {
          ...getCalculationsValues(SPIRIT_REDUCTION_CALCULATIONS_FIELDS.CBULK_X_STRENGTH),
          Component: Input,
          noMargin: true
        },
        {
          ...getCalculationsValues(SPIRIT_REDUCTION_CALCULATIONS_FIELDS.TOTAL_WATER),
          Component: Input,
          noMargin: true
        }
      ]
    },
    {
      key: 'thirdRow',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.mainInfoTableColumns,
      fields: [
        {
          ...getCalculationsValues(SPIRIT_REDUCTION_CALCULATIONS_FIELDS.LALC_CALCULATION),
          Component: Input,
          noMargin: true
        },
        {
          ...getCalculationsValues(SPIRIT_REDUCTION_CALCULATIONS_FIELDS.NEW_METER_READING),
          Component: Input,
          noMargin: true
        }
      ]
    },
    {
      key: 'fourthRow',
      Component: AdelphiFieldsRow,
      fieldContainerClassName: styles.mainInfoTableColumns,
      fields: [
        {
          ...getCalculationsValues(SPIRIT_REDUCTION_CALCULATIONS_FIELDS.MINUS_CBULK),
          Component: Input,
          noMargin: true
        },
        {
          key: 'blankSpace',
          Component: () => <div />
        }
      ]
    }
  ];
};
